// import { reactLocalStorage } from 'reactjs-localstorage';
// // const BASE_URL = 'http://3.110.105.243:8157/api/v1/user/';
// // const BASE_URL = 'http://3.110.105.243:5736/api/v1/user/';
// // const BASE_URL = 'http://43.205.231.210:8167/api/v1/user/';

// // const BASE_URL = 'http://15.206.167.101:8167/api/v1/user/'; //Production Backend
// const BASE_URL = 'https://api.thewinners2.in/api/v1/user/'; //Live Backend

// const ALLOW_ORIGIN = '15.206.167.101:8167';
// const USER_TYPE = 'User';

// function get(endpoint, params) {
//     return requestData(endpoint, params);
// }

// function post(endpoint, params) {
//     return requestData(endpoint, params, 'POST');
// }

// function put(endpoint, params) {
//     return requestData(endpoint, params, 'PUT');
// }

// function deletemethod(endpoint, params) {
//     return requestData(endpoint, params, 'DELETE');
// }

// async function requestData(url, data = {}, method = 'GET') {
//     let xhr = new XMLHttpRequest();
//     xhr.open(method, BASE_URL + url);
//     if (checkingAuth()) xhr.setRequestHeader('authorization', checkingAuth());
//     xhr.setRequestHeader('Content-Type', 'application/json');
//     xhr.setRequestHeader('Access-Control-Allow-Origin', ALLOW_ORIGIN);
//     xhr.setRequestHeader('userType', USER_TYPE);

//     return new Promise((resolve, reject) => {
//         // console.log("string mal", JSON.stringify(data));
//         if (method == 'GET') {
//             xhr.send();
//         } else {
//             xhr.send(JSON.stringify(data));
//         }
//         xhr.onload = () => {
//             console.log(xhr.status);
//             // console.log("jdjgfdgdfgdgfdgfdgdf", xhr);
//             let response = JSON.parse(xhr.response);
//             // console.log(response ,"sdgdgdfgdfgdf");

//             if (xhr.status === 200 || xhr.status === 400 || xhr.status === 201 || xhr.status === 403 || xhr.status === 500 || xhr.status === 406) {
//                 resolve(response);
//             } else {
//                 reject(response);
//             }
//         };
//     });
// }

// async function fileUplode(url, method, file, object_get = {}, tokenCustom = null) {
//     let token = '';
//     let user = reactLocalStorage.get('token');

//     if (user && user != null && Object.keys(user).length > 0) {
//         token = user;
//     }
//     // let bash_url = "http://13.127.101.102:5011/api/v1/";
//     let apiUrl = BASE_URL + url;

//     if (token != '') {
//         var toooo = token;
//     }
//     //  console.log("tokenn",toooo);
//     let headers = {
//         // 'Accept': 'application/json',
//         // "Content-Type": "multipart/form-data",
//         // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
//         authorization: toooo,
//         userType: 'User',
//         // 'Authorization': 'Bearer ' + login_status,
//     };

//     return await fetch(apiUrl, {
//         method: method,
//         body: file,
//         redirect: 'follow',
//         headers: headers,
//     })
//         .then(response => {
//             console.log("responseee", response, headers);
//             return response.json();
//         })
//         .then(
//             result => {
//                 console.log('ResponIMG', result);
//                 return result;
//             },
//             error => {
//                 return error;
//             }
//         );
// }

// async function fileVideoUplode(url, method, file, object_get = {}, tokenCustom = null) {
//     let token = '';
//     let user = reactLocalStorage.get('token');
//     // console.log("UserTok", user);
//     if (user && user != null && Object.keys(user).length > 0) {
//         token = user;
//     }
//     // let bash_url = "http://13.127.101.102:5011/api/v1/";
//     let apiUrl = BASE_URL + url;
//     // let data = new FormData();
//     // data.append("image", file);
//     // Object.keys(object_get).forEach(function (key) {
//     //   let ddd = object_get[key];
//     //   data.append(key, ddd);
//     // });

//     if (token != '') {
//         var toooo = token;
//     }
//     //  console.log("tokenn",toooo);
//     let headers = {
//         // 'Accept': 'application/json',
//         // "Content-Type": "multipart/form-data",
//         // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
//         authorization: toooo,
//         userType: 'User',
//         // 'Authorization': 'Bearer ' + login_status,
//     };

//     return await fetch(apiUrl, {
//         method: method,
//         body: file,
//         redirect: 'follow',
//         headers: headers,
//     })
//         .then(response => {
//             // console.log("responseee", response, headers);
//             return response.json();
//         })
//         .then(
//             result => {
//                 console.log('ResponIMG', result);
//                 return result;
//             },
//             error => {
//                 return error;
//             }
//         );
// }

// function checkingAuth() {
//     let token = reactLocalStorage.get('token');
//     // console.log('TOKEn', token);

//     if (token) {
//         return token;
//     }
//     return false;
// }

// export default {
//     requestData,
//     get,
//     post,
//     put,
//     deletemethod,
//     fileUplode,
//     fileVideoUplode,
// };

import { toast } from "react-toastify";
import { reactLocalStorage } from "reactjs-localstorage";
// const BASE_URL = 'http://3.110.105.243:8157/api/v1/user/';
// const BASE_URL = 'http://3.110.105.243:5736/api/v1/user/';
// const BASE_URL = 'http://43.205.231.210:8167/api/v1/user/';

// const BASE_URL = 'http://15.206.167.101:8167/api/v1/user/'; //Production Backend
const BASE_URL = "https://api.thewinners2.in/api/v1/user/"; //Live Backend

const ALLOW_ORIGIN = "15.206.167.101:8167";
const USER_TYPE = "User";

function get(endpoint, params) {
  return requestData(endpoint, params);
}

function post(endpoint, params) {
  return requestData(endpoint, params, "POST");
}

function put(endpoint, params) {
  return requestData(endpoint, params, "PUT");
}

function deletemethod(endpoint, params) {
  return requestData(endpoint, params, "DELETE");
}

async function requestData(url, data = {}, method = "GET") {
  let xhr = new XMLHttpRequest();
  xhr.open(method, BASE_URL + url);
  if (checkingAuth()) xhr.setRequestHeader("authorization", checkingAuth());
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("Access-Control-Allow-Origin", ALLOW_ORIGIN);
  xhr.setRequestHeader("userType", USER_TYPE);

  return new Promise((resolve, reject) => {
    // console.log("string mal", JSON.stringify(data));
    if (method == "GET") {
      xhr.send();
    } else {
      xhr.send(JSON.stringify(data));
    }
    xhr.onload = () => {
      console.log(xhr.status);
      // console.log("jdjgfdgdfgdgfdgfdgdf", xhr);
      let response = JSON.parse(xhr.response);
      // console.log(response ,"sdgdgdfgdfgdf");

      // Handle 401 status code
      if (xhr.status === 401) {
        handleUnauthorizedAccess(response);
        reject(response);
        return;
      }

      if (
        xhr.status === 200 ||
        xhr.status === 400 ||
        xhr.status === 201 ||
        xhr.status === 403 ||
        xhr.status === 500 ||
        xhr.status === 406
      ) {
        resolve(response);
      } else {
        reject(response);
      }
    };
  });
}

async function fileUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("token");

  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "User",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      console.log("responseee", response, headers);

      // Handle 401 status code for file upload
      if (response.status === 401) {
        return response.json().then((responseData) => {
          handleUnauthorizedAccess(responseData);
          throw responseData;
        });
      }

      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      }
    );
}

async function fileVideoUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("token");
  // console.log("UserTok", user);
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;

  if (token != "") {
    var toooo = token;
  }

  let headers = {
    authorization: toooo,
    userType: "User",
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      // console.log("responseee", response, headers);

      // Handle 401 status code for video upload
      if (response.status === 401) {
        return response.json().then((responseData) => {
          handleUnauthorizedAccess(responseData);
          throw responseData;
        });
      }

      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      }
    );
}

function checkingAuth() {
  let token = reactLocalStorage.get("token");
  // console.log('TOKEn', token);

  if (token) {
    return token;
  }
  return false;
}

// Handle unauthorized access (401 status code)
function handleUnauthorizedAccess(response) {
  if (response?.data?.tokenExpired === true) {
    // Token expired
    reactLocalStorage.remove("token");
    // reactLocalStorage.remove("user");
    window.location.href = "/profile";
    // If you have toast notification, uncomment the line below
    toast.error("Session expired. Please login again.");
    console.error("Session expired. Please login again.");
  } else {
    // Invalid or missing credentials
    reactLocalStorage.clear();
    window.location.href = "/profile";
    // If you have toast notification, uncomment the line below
    toast.error("Please login to continue.");
    console.error("Please login to continue.");
  }
}

export default {
  requestData,
  get,
  post,
  put,
  deletemethod,
  fileUplode,
  fileVideoUplode,
  handleUnauthorizedAccess,
};
